'use strict';

var pixi_js = require('pixi.js');
var SlidingNumber = require('./SlidingNumber.js');

var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class Trackpad {
  constructor(options) {
    __publicField(this, "xAxis");
    __publicField(this, "yAxis");
    __publicField(this, "_isDown");
    __publicField(this, "_globalPosition");
    __publicField(this, "_frame");
    __publicField(this, "_bounds");
    __publicField(this, "_dirty");
    __publicField(this, "disableEasing", false);
    this.xAxis = new SlidingNumber.SlidingNumber({
      ease: options.xEase,
      maxSpeed: options.maxSpeed,
      constrain: options.constrain
    });
    this.yAxis = new SlidingNumber.SlidingNumber({
      ease: options.yEase,
      maxSpeed: options.maxSpeed,
      constrain: options.constrain
    });
    this.disableEasing = options.disableEasing ?? false;
    this._frame = new pixi_js.Rectangle();
    this._bounds = new pixi_js.Rectangle();
    this._globalPosition = new pixi_js.Point();
  }
  pointerDown(pos) {
    this._globalPosition = pos;
    this.xAxis.grab(pos.x);
    this.yAxis.grab(pos.y);
    this._isDown = true;
  }
  pointerUp() {
    this._isDown = false;
  }
  pointerMove(pos) {
    this._globalPosition = pos;
  }
  update() {
    if (this._dirty) {
      this._dirty = false;
      this.xAxis.min = this._bounds.left;
      this.xAxis.min = this._bounds.right - this._frame.width;
      this.xAxis.min = this._bounds.top;
      this.xAxis.min = this._bounds.bottom - this._frame.height;
    }
    if (this._isDown) {
      this.xAxis.hold(this._globalPosition.x);
      this.yAxis.hold(this._globalPosition.y);
    } else {
      this.xAxis.slide(this.disableEasing);
      this.yAxis.slide(this.disableEasing);
    }
  }
  resize(w, h) {
    this._frame.x = 0;
    this._frame.width = w;
    this._frame.y = 0;
    this._frame.height = h;
    this._dirty = true;
  }
  setBounds(minX, maxX, minY, maxY) {
    this._bounds.x = minX;
    this._bounds.width = maxX - minX;
    this._bounds.y = minY;
    this._bounds.height = maxY - minY;
    this._dirty = true;
  }
  get x() {
    return this.xAxis.value;
  }
  get y() {
    return this.yAxis.value;
  }
}

exports.Trackpad = Trackpad;
//# sourceMappingURL=Trackpad.js.map
